
import { defineComponent } from "vue";
import Header from "@/components/HomeNav.vue";

export default defineComponent({
  name: "Cart",
  components: {
    Header,
  },
  data() {
    return {
      selected_all: false,
      HospitalList: [
        {
          name: "Samitivej Srinakarin",
          id: "samitivej_srinakarin",
        },
        {
          name: "Samitivej Children's Hospital Srinakarin",
          id: "samitivej_children_s_hospital_srinakarin",
        },
        {
          name: "Samitivej Sukhumvie",
          id: "samitivej_sukhumvie",
        },
      ],
      packageList: [
        {
          title: "Health check One",
          id: "Health_check5f864843",
          price: 0,
          priceAll: 1290,
          statusShow: false,
          select: false,
          riskStatus: "high",
          package: [
            {
              select: true,
              id: "Health_check5fssdf864843",
              price: 1290,
              salePrice: 300,
              include: [
                "ตรวจความสมบูรณ์ของเลือด",
                "ตรวจความสมบูรณ์ของเลือด2",
                "ตรวจความสมบูรณ์ของเลือด3",
              ],
            },
            {
              select: false,
              id: "Health_check5f86ads4843",
              price: 1190,
              include: ["ตรวจความสมบูรณ์ของเลือด"],
            },
          ],
        },
        {
          title: "Health check One",
          id: "Health_check5f864843",
          price: 1490,
          priceAll: 1290,
          statusShow: false,
          select: false,
          riskStatus: "moderate",
          package: [
            {
              select: false,
              id: "Health_check5fssdf864843",
              price: 1290,
              include: [
                "ตรวจความสมบูรณ์ของเลือด",
                "ตรวจความสมบูรณ์ของเลือด2",
                "ตรวจความสมบูรณ์ของเลือด3",
              ],
            },
            {
              select: false,
              id: "Health_check5f86ads4843",
              price: 1190,
              include: ["ตรวจความสมบูรณ์ของเลือด"],
            },
          ],
        },
        {
          title: "Health check One",
          id: "Health_check5f864843",
          price: 0,
          priceAll: 1290,
          statusShow: false,
          select: false,
          riskStatus: "low",
          package: [
            {
              select: true,
              id: "Health_check5fssdf864843",
              salePrice: 300,
              price: 1290,
              include: [
                "ตรวจความสมบูรณ์ของเลือด",
                "ตรวจความสมบูรณ์ของเลือด2",
                "ตรวจความสมบูรณ์ของเลือด3",
              ],
            },
            {
              select: false,
              id: "Health_check5f86ads4843",
              salePrice: 300,
              price: 1190,
              include: ["ตรวจความสมบูรณ์ของเลือด"],
            },
          ],
        },
      ],
      cardList: [
        {
          type: "visa",
          cardID: "1111-1111-1111-1111",
          imageURL:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/5/5e/Visa_Inc._logo.svg/2560px-Visa_Inc._logo.svg.png",
          showCardId: "xxxx",
          id: "mockup_id_12345633685",
        },
      ],
      paymentTypeSelected: "",
      paymentIDSelected: "",
    };
  },
  methods: {
    numberWithCommasLine(number: number) {
      return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + ".-";
    },
    numberWithCommas(number: number) {
      return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    selectSubPackage(listId: any, packageId: any) {
      const arr = this.packageList[listId].package;
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].id == packageId) {
          this.packageList[listId].package[i].select = !arr[i].select;
        }
      }
      let sameValue = true;
      let statusFirstSubPackage = this.packageList[listId].package[0].select;
      for (let i = 0; i < arr.length; i++) {
        if (
          this.packageList[listId].package[i].select !== statusFirstSubPackage
        ) {
          sameValue = false;
        }
      }
      if (sameValue) {
        this.packageList[listId].select = statusFirstSubPackage;
        this.checkPackageSelected();
      }
    },
    selectAllPackage() {
      for (let i = 0; i < this.packageList.length; i++) {
        this.packageList[i].select = !this.selected_all;
        for (
          let index = 0;
          index < this.packageList[i].package.length;
          index++
        ) {
          this.packageList[i].package[index].select = !this.selected_all;
        }
      }
      this.checkPackageSelected();
    },
    selectPackage(listId: any) {
      const arr = this.packageList[listId].package;
      const value = !this.packageList[listId].select;
      this.packageList[listId].select = value;
      for (let i = 0; i < arr.length; i++) {
        this.packageList[listId].package[i].select = value;
      }
      this.checkPackageSelected();
    },
    checkPackageSelected() {
      let sameValue = true;
      let statusFirstSubPackage = this.packageList[0].select;
      for (let i = 0; i < this.packageList.length; i++) {
        if (this.packageList[i].select !== statusFirstSubPackage) {
          sameValue = false;
        }
      }
      if (sameValue) {
        this.selected_all = statusFirstSubPackage;
      }
    },
    selectPayment(paymentType: string, paymentId: string) {
      this.paymentTypeSelected = paymentType;
      this.paymentIDSelected = paymentId;
    },
  },
});
